import { useTranslation } from 'next-i18next';

const ReportDisclaimers: React.FC = () => {
  const { t } = useTranslation('common');

  return (
    <div className="pt-10 text-center text-sm text-[#999999]">
      {t(
        'We track and analyze user activity using public Instagram data. Click any post, profile picture, or hashtag to view it on Instagram.'
      )}
    </div>
  );
};

export default ReportDisclaimers;
